module.exports = __webpack_public_path__ + "img/yuding.9a44254e.png";